"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectionManager = void 0;
const connection_1 = require("./core/connection");
const constants_1 = require("./core/constants");
const types_1 = require("./core/types");
const utils_1 = require("./core/utils");
class ConnectionManager {
    constructor(platform) {
        this.platform = platform;
        this.connection = null;
        this.popupWindow = null;
        this.handleMessage = (e) => {
            var _a, _b;
            if (!(0, utils_1.validateOrigin)(e.origin)) {
                return;
            }
            const validatedOrigin = e.origin;
            if (!this.popupWindow) {
                return;
            }
            if (e.data.event === types_1.PopupEvent.HANDSHAKE && !this.connection) {
                if (!this.verifyAndResetNonce((_a = e.data.payload) === null || _a === void 0 ? void 0 : _a.nonce)) {
                    return;
                }
                this.popupWindow.postMessage({
                    event: types_1.PopupEvent.HANDSHAKE_ACK,
                    payload: {
                        platform: this.platform,
                    },
                }, validatedOrigin);
                this.connection = new connection_1.Connection(validatedOrigin, this.popupWindow);
                (_b = this.connectionUpdatedCallback) === null || _b === void 0 ? void 0 : _b.call(this, this.connection);
            }
            if (!this.connection) {
                return;
            }
            this.connection.runHandlersForEvent(e.data.event, e.data.payload);
            if (e.data.event === types_1.PopupEvent.POPUP_CLOSED && this.connection) {
                this.resetConnection();
                this.popupWindow = null;
            }
        };
    }
    initialize() {
        window.addEventListener('message', this.handleMessage);
        return this;
    }
    tearDown() {
        window.removeEventListener('message', this.handleMessage);
        this.resetConnection();
        return this;
    }
    open({ url, widthPx = constants_1.DEFAULT_POPUP_WIDTH_PX, heightPx = constants_1.DEFAULT_POPUP_HEIGHT_PX, nonce, }) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if ((_a = this.popupWindow) === null || _a === void 0 ? void 0 : _a.closed) {
                this.resetConnectionAndPopupWindow();
            }
            if (this.popupWindow) {
                return;
            }
            this.initialize();
            if (nonce) {
                this.nonce = nonce;
            }
            const left = window.screenX + (window.innerWidth - widthPx) / 2;
            const top = window.screenY + (window.innerHeight - heightPx) / 2;
            this.popupWindow = (0, utils_1.openPopup)({
                height: heightPx,
                left,
                top,
                url: typeof url === 'string' ? url : undefined,
                width: widthPx,
            });
            if (url instanceof Promise) {
                this.setUrl(yield url);
            }
        });
    }
    close() {
        if (!this.popupWindow) {
            return;
        }
        this.popupWindow.close();
        this.resetConnectionAndPopupWindow();
    }
    onConnectionUpdated(callback) {
        this.connectionUpdatedCallback = callback;
        return this;
    }
    getConnection() {
        return this.connection;
    }
    setUrl(url) {
        if (!this.popupWindow) {
            return;
        }
        this.popupWindow.location = url;
    }
    resetConnectionAndPopupWindow() {
        this.resetConnection();
        this.popupWindow = null;
    }
    resetConnection() {
        var _a, _b;
        (_a = this.connection) === null || _a === void 0 ? void 0 : _a.resetHandlers();
        this.connection = null;
        (_b = this.connectionUpdatedCallback) === null || _b === void 0 ? void 0 : _b.call(this, this.connection);
    }
    verifyAndResetNonce(uncheckedNonce) {
        if (!this.nonce) {
            return true;
        }
        const result = uncheckedNonce === this.nonce;
        if (result) {
            this.nonce = undefined;
        }
        return result;
    }
}
exports.ConnectionManager = ConnectionManager;
//# sourceMappingURL=connection-manager.js.map